import React from 'react'
import * as imges from '../constant/imges';
import { Link } from 'react-router-dom';
import { facebook,linkedin,twiter } from '../constant/svgs';

const Footer = () => {
    return (
        <div className='footerSty container-fluid pt-5 pb-2'>
            <div className='row'>
                <div className='col-lg-3 col-md-6 mb-4'>
                    <div className='footerlogo'>
                        <img src={imges.brandLogo} alt='brandLogo' />
                    </div>
                    <h1 className='text-white mt-4 text-center'>WiserBee</h1>
                    <p className='text-white text-center'>Smarter - Scholar - Wise</p>
                </div>
                <div className='col-lg-3 col-md-6 mb-4'>
                    <h4 className='text-white mb-4'>Company</h4>
                    <ul className='list-unstyled'>
                        <li><Link to="/" className='text-white text-decoration-none mb-2 d-block'>Home</Link></li>
                        <li><Link to="/" className='text-white text-decoration-none mb-2 d-block'>About Us</Link></li>
                        <li><Link to="/" className='text-white text-decoration-none mb-2 d-block'>Our Features</Link></li>
                        <li><Link to="/careers" className='text-white text-decoration-none mb-2 d-block'>Careers</Link></li>
                        <li><Link to="/news" className='text-white text-decoration-none mb-2 d-block'>News</Link></li>
                        <li><Link to="/contact-us" className='text-white text-decoration-none mb-2 d-block'>Contact Us</Link></li>
                    </ul>
                </div>
                <div className='col-lg-3 col-md-6 mb-4'>
                    <h4 className='text-white mb-4'>Get Help</h4>
                    <ul className='list-unstyled'>
                        <li><Link to="/legal/privacy" className='text-white text-decoration-none mb-2 d-block'>Privacy Policy</Link></li>
                        <li><Link to="/security" className='text-white text-decoration-none mb-2 d-block'>Security Protection</Link></li>
                        <li><Link to="/legal/gdpr" className='text-white text-decoration-none mb-2 d-block'>GDPR</Link></li>
                        <li><Link to="/legal/cookies-policy" className='text-white text-decoration-none mb-2 d-block'>Cookie Policy</Link></li>
                        <li><Link to="/our-global-network" className='text-white text-decoration-none mb-2 d-block'>Our Global Network</Link></li>
                    </ul>
                </div>
                <div className='col-lg-3 col-md-6 mb-4'>
                    <h4 className='text-white mb-4'>Follow Us</h4>
                    <div className='d-flex gap-3'>
                        <Link to='' className='social_link'>{facebook}</Link>
                        <Link to='https://twitter.com/wiser_bee5' className='social_link'>{twiter}</Link>
                        <Link to='https://www.linkedin.com/company/wiserbee' className='social_link'>{linkedin}</Link>
                    </div>
                    <div className='mt-4'>
                        <Link className="reqforDemoBtn" to="/req-demo">Request For Demo</Link>
                    </div>
                </div>
            </div>
            <div className='rightandresv'>
                <p className='text-center text-white mt-3'>WiserBee © 2024. All rights reserved</p>
            </div>
        </div>
    )
}

export default Footer